import { decodeText } from "../../../utils/richText";

export const getNodesCount = (node) => node["@nodes"] && node["@nodes"].filter((n) => n !== "link").length;

export const getLink = (node, nodeName) => {
    const linkNode = nodeName === "link" ? node[nodeName] : node[nodeName].link;
    const label = linkNode && decodeText(linkNode.label);

    return { linkNode, label };
};

// Child node names that are navigation items. The main navigation node also carries the
// header settings (promo link, trust items) as child nodes, which must not render as menu
// entries.
export const navChildNames = (node) =>
    node && node["@nodes"]
        ? node["@nodes"].filter((name) => {
              const type = node[name] && node[name]["@nodeType"];
              return typeof type === "string" && type.startsWith("mgnl:nav-ecommerce-");
          })
        : [];

// Checkbox values arrive as booleans (or strings); an absent value keeps the given default so
// navigations authored before the field existed behave as before.
export const flag = (value, fallback) => (value === undefined || value === null || value === "" ? fallback : value === true || value === "true");

export const splitLines = (text) =>
    typeof text === "string"
        ? text
              .split(/\r?\n/)
              .map((line) => line.trim())
              .filter(Boolean)
        : [];